var _filter, _filter2, _rect, _rect2, _text, _text2, _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvgProcessThread(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 420",
    fontFamily: "'Segoe UI', Arial, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg2",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0f0f1a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1a1a2e"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "processGrad",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#6c63ff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#4338ca"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "threadGrad",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#f472b6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#db2777"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coreGrad",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#10b981"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#059669"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "glow2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "shadow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 6,
    floodColor: "#000",
    floodOpacity: 0.4
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 750,
    height: 420,
    rx: 16,
    fill: "url(#bg2)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 750,
    height: 420,
    rx: 16,
    fill: "none",
    stroke: "#6c63ff",
    strokeWidth: 1,
    opacity: 0.3
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 40,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontSize: 20,
    fontWeight: 700,
    opacity: 0
  }, "\n    Processes, Threads &amp; CPU Cores\n    ", /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.6s",
    fill: "freeze"
  }))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 60,
    textAnchor: "middle",
    fill: "#64748b",
    fontSize: 13,
    opacity: 0
  }, "\n    Understanding the building blocks of execution\n    ", /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.6s",
    begin: "0.2s",
    fill: "freeze"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.6s",
    begin: "0.4s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 85,
    width: 200,
    height: 220,
    rx: 14,
    fill: "#1a1a35",
    stroke: "url(#processGrad)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 85,
    width: 200,
    height: 45,
    rx: 14,
    fill: "url(#processGrad)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 110,
    width: 200,
    height: 20,
    fill: "url(#processGrad)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 113,
    textAnchor: "middle",
    fill: "#fff",
    fontSize: 22
  }, "\uD83C\uDFEA"), /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 150,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontSize: 16,
    fontWeight: 700
  }, "PROCESS"), /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 170,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 12
  }, "= A Restaurant"), /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 185,
    x2: 210,
    y2: 185,
    stroke: "#6c63ff",
    strokeWidth: 0.5,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 207,
    textAnchor: "middle",
    fill: "#cbd5e1",
    fontSize: 11
  }, "An instance of a"), /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 224,
    textAnchor: "middle",
    fill: "#cbd5e1",
    fontSize: 11
  }, "running program"), /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 250,
    textAnchor: "middle",
    fill: "#64748b",
    fontSize: 10
  }, "The whole operation"), /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 266,
    textAnchor: "middle",
    fill: "#64748b",
    fontSize: 10
  }, "managed by the OS"), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 85,
    width: 200,
    height: 220,
    rx: 14,
    fill: "none",
    stroke: "#6c63ff",
    strokeWidth: 1,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.2;0.6;0.2",
    dur: "3s",
    repeatCount: "indefinite"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.6s",
    begin: "0.8s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 85,
    width: 200,
    height: 220,
    rx: 14,
    fill: "#1a1a35",
    stroke: "url(#threadGrad)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 85,
    width: 200,
    height: 45,
    rx: 14,
    fill: "url(#threadGrad)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 110,
    width: 200,
    height: 20,
    fill: "url(#threadGrad)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 113,
    textAnchor: "middle",
    fill: "#fff",
    fontSize: 22
  }, "\uD83D\uDC68\u200D\uD83C\uDF73"), /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 150,
    textAnchor: "middle",
    fill: "#f9a8d4",
    fontSize: 16,
    fontWeight: 700
  }, "THREADS"), /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 170,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 12
  }, "= Chefs in Kitchen"), /*#__PURE__*/React.createElement("line", {
    x1: 305,
    y1: 185,
    x2: 445,
    y2: 185,
    stroke: "#f472b6",
    strokeWidth: 0.5,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 207,
    textAnchor: "middle",
    fill: "#cbd5e1",
    fontSize: 11
  }, "Workers inside"), /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 224,
    textAnchor: "middle",
    fill: "#cbd5e1",
    fontSize: 11
  }, "a process"), /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 250,
    textAnchor: "middle",
    fill: "#64748b",
    fontSize: 10
  }, "Execute the actual"), /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 266,
    textAnchor: "middle",
    fill: "#64748b",
    fontSize: 10
  }, "tasks and operations"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 295,
    fill: "#fff",
    fontSize: 14,
    opacity: 0.7
  }, "\n        \uD83D\uDC68\u200D\uD83C\uDF73\n        ", /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "295;290;295",
    dur: "1.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    x: 345,
    y: 295,
    fill: "#fff",
    fontSize: 14,
    opacity: 0.7
  }, "\n        \uD83D\uDC68\u200D\uD83C\uDF73\n        ", /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "295;288;295",
    dur: "1.8s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    x: 380,
    y: 295,
    fill: "#fff",
    fontSize: 14,
    opacity: 0.7
  }, "\n        \uD83D\uDC68\u200D\uD83C\uDF73\n        ", /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "295;291;295",
    dur: "1.3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    x: 415,
    y: 295,
    fill: "#fff",
    fontSize: 14,
    opacity: 0.7
  }, "\n        \uD83D\uDC68\u200D\uD83C\uDF73\n        ", /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "295;287;295",
    dur: "2s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 85,
    width: 200,
    height: 220,
    rx: 14,
    fill: "none",
    stroke: "#f472b6",
    strokeWidth: 1,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.2;0.6;0.2",
    dur: "3s",
    begin: "0.5s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.6s",
    begin: "1.2s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 85,
    width: 200,
    height: 220,
    rx: 14,
    fill: "#1a1a35",
    stroke: "url(#coreGrad)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 85,
    width: 200,
    height: 45,
    rx: 14,
    fill: "url(#coreGrad)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 110,
    width: 200,
    height: 20,
    fill: "url(#coreGrad)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 610,
    y: 113,
    textAnchor: "middle",
    fill: "#fff",
    fontSize: 22
  }, "\uD83D\uDD25"), /*#__PURE__*/React.createElement("text", {
    x: 610,
    y: 150,
    textAnchor: "middle",
    fill: "#6ee7b7",
    fontSize: 16,
    fontWeight: 700
  }, "CPU CORES"), /*#__PURE__*/React.createElement("text", {
    x: 610,
    y: 170,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 12
  }, "= Kitchen Stations"), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 185,
    x2: 680,
    y2: 185,
    stroke: "#10b981",
    strokeWidth: 0.5,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("text", {
    x: 610,
    y: 207,
    textAnchor: "middle",
    fill: "#cbd5e1",
    fontSize: 11
  }, "Physical hardware"), /*#__PURE__*/React.createElement("text", {
    x: 610,
    y: 224,
    textAnchor: "middle",
    fill: "#cbd5e1",
    fontSize: 11
  }, "where threads run"), /*#__PURE__*/React.createElement("text", {
    x: 610,
    y: 250,
    textAnchor: "middle",
    fill: "#64748b",
    fontSize: 10
  }, "Threads are scheduled"), /*#__PURE__*/React.createElement("text", {
    x: 610,
    y: 266,
    textAnchor: "middle",
    fill: "#64748b",
    fontSize: 10
  }, "on cores by the OS"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 545,
    y: 280,
    width: 20,
    height: 15,
    rx: 3,
    fill: "#10b981",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;0.9;0.3",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 573,
    y: 280,
    width: 20,
    height: 15,
    rx: 3,
    fill: "#10b981",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;0.9;0.3",
    dur: "1.4s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 601,
    y: 280,
    width: 20,
    height: 15,
    rx: 3,
    fill: "#10b981",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;0.9;0.3",
    dur: "0.8s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 629,
    y: 280,
    width: 20,
    height: 15,
    rx: 3,
    fill: "#10b981",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;0.9;0.3",
    dur: "1.6s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 657,
    y: 280,
    width: 20,
    height: 15,
    rx: 3,
    fill: "#10b981",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;0.9;0.3",
    dur: "1.2s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 85,
    width: 200,
    height: 220,
    rx: 14,
    fill: "none",
    stroke: "#10b981",
    strokeWidth: 1,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.2;0.6;0.2",
    dur: "3s",
    begin: "1s",
    repeatCount: "indefinite"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.5s",
    begin: "1.6s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 195,
    x2: 275,
    y2: 195,
    stroke: "#94a3b8",
    strokeWidth: 2,
    strokeDasharray: "6,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 18,
    to: 0,
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    x: 257,
    y: 188,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 10
  }, "has"), /*#__PURE__*/React.createElement("line", {
    x1: 475,
    y1: 195,
    x2: 510,
    y2: 195,
    stroke: "#94a3b8",
    strokeWidth: 2,
    strokeDasharray: "6,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 18,
    to: 0,
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    x: 492,
    y: 188,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 10
  }, "run on"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.6s",
    begin: "2s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 330,
    width: 670,
    height: 70,
    rx: 12,
    fill: "#12121f",
    stroke: "#6c63ff",
    strokeWidth: 1,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 357,
    textAnchor: "middle",
    fill: "#e2e8f0",
    fontSize: 13,
    fontWeight: 600
  }, "\n      \uD83D\uDCA1 A Process (restaurant) has multiple Threads (chefs) that execute on CPU Cores (kitchen stations)\n    "), /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 380,
    textAnchor: "middle",
    fill: "#64748b",
    fontSize: 12
  }, "\n      Node.js uses only ONE thread \u2192 only ONE core \u2192 massive resource waste on multi-core systems\n    "))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgProcessThread);
export default __webpack_public_path__ + "static/media/svg-process-thread.1d5f13c5805d6ae9451b17b0a2bce500.svg";
export { ForwardRef as ReactComponent };